import { useState } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import Popper from "../components/popper";
import "../utils/tailwind.css";
import NofificationDrawer from "./components/notification-drawer";

import ProfilePicture from "./components/profile-picture";
import BackIcon from "../components/svg/back";
import Modal from "../components/modal";
import { useStore } from "../utils/context";
import GyaankoolLogo from "../assets/images/gyaankoollogo.png";
import { useNavigate } from "react-router-dom";
import Const from "../utils/constant";
import { useLocation } from "react-router-dom";

export default function AppNavbar() {
  const [isPopperOpen, setIsPopperOpen] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const { handleLogout } = useStore();
  const [isModalOpen, setIsOpenModal] = useState(false);
  const handleLogoutClick = () => {
    handleLogout();
  };

  const location = useLocation();

  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  const showBackButton = (pathname) => {
    if (Const.BACK_BUTTON_SCREENS.includes(pathname)) return true;

    return Const.BACK_BUTTON_SCREENS.some((pattern) => {
      const regex = new RegExp(`^${pattern.replace(":id", "\\d+")}$`);
      return regex.test(pathname);
    });
  };

  return (
    <Navbar expand="lg" className="fixed-navbar  bg-[#FFD869]  py-2" style={{ zIndex: "2000" }}>
      <Modal
        title="Confirm"
        desc="Are you sure you want to logout ?"
        isModalOpen={isModalOpen}
        setIsOpen={setIsOpenModal}
        handleSubmit={handleLogoutClick}
        confirmButtonLabel="Logout"
      />

      <NofificationDrawer isOpen={isDrawerOpen} setIsOpen={setIsDrawerOpen} />
      <ProfilePicture isOpen={isProfileOpen} setIsOpen={setIsProfileOpen} />
      <Container fluid>
        <img src={GyaankoolLogo} className="w-[140px] h-[40px] object-fill" alt="Logo" />
        {showBackButton(location.pathname) && (
          <div className="flex items-center ml-5 space-x-6">
            <div
              role="button"
              tabIndex={0}
              className="text-black pl-[6rem] text-[18px]  focus:outline-none"
              onClick={handleGoBack}
            >
              <span>Back</span>
            </div>
          </div>
        )}

        <Nav className="ms-auto d-flex align-items-center !justify-between space-x-8">
          <Popper placement="bottom" setIsOpen={setIsPopperOpen} isOpen={isPopperOpen} onOutsideClick={() => setIsPopperOpen(false)}>
            <Popper.Trigger>
              {({ setAnchorElement }) => (
                <div ref={setAnchorElement}>
                  <div onClick={() => setIsPopperOpen(true)} className=" text-black px-3 py-2 mr-6 rounded cursor-pointer">
                    Admin
                  </div>
                </div>
              )}
            </Popper.Trigger>
            <Popper.Content>
              <div className="p-3 w-[300px] h-[135px] rounded-[8px] bg-[#fffbf4] border-[1px] border-[#F0F0F0] shadow-[0px_14px_54px_0px_rgba(0,0,0,0.1)] mr-9 mt-2.5">
                <div className="flex space-x-3 items-center">
                  <div className="text-[16px] text-[#2C2C2C]">Admin Panel | Gyaankool</div>
                </div>
                <div role="button" tabIndex={0} className="flex space-x-3 mt-3 cursor-pointer" onClick={() => setIsOpenModal(true)}>
                  <BackIcon className="text-black" />
                  <span className="text-[#FB325E] text-[17px]">Logout</span>
                </div>
              </div>
            </Popper.Content>
          </Popper>
        </Nav>
      </Container>
    </Navbar>
  );
}
